export default __webpack_public_path__ + "static/media/more-end-game.2df6aa44.yaml";